import { AssistanceEquipment } from "@edp-models/assistance-equipment.model";
import { AssistanceRequestList } from "@edp-models/assistance-request.model";
import { Action } from "@ngrx/store";


export enum EAssistanceRequestActions {
    GetSymptoms = "[AssistanceRequest] Get Symptoms",
    SetSymptoms = "[AssistanceRequest] Set Symptoms",
    GetEquipments = "[AssistanceRequest] Get Equipments",
    SetEquipments = "[AssistanceRequest] Set Equipments",
}

export class GetSymptoms implements Action {
    public readonly type = EAssistanceRequestActions.GetSymptoms;
}

export class SetSymptoms implements Action {
    public readonly type = EAssistanceRequestActions.SetSymptoms;
    constructor(public assistanceRequest: Array<AssistanceRequestList>) {}
}

export class GetEquipments implements Action {
    public readonly type = EAssistanceRequestActions.GetEquipments;
}

export class SetEquipments implements Action {
    public readonly type = EAssistanceRequestActions.SetEquipments;
    constructor(public equipments: Array<AssistanceEquipment>) {}
}

export type AssistanceRequestActions = GetSymptoms | SetSymptoms | GetEquipments | SetEquipments;
